import React, { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { isNull } from "../../util/check";

function TableTopFilter(props) {
  // import
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedTab = useMemo(() => {
    if (isNull(searchParams.get("tab"))) {
      return 1;
    }
    return Number(searchParams.get("tab"));
  }, [searchParams]);

  return (
    <>
      <TableTopFilterWrapper>
        {props.tabList.map((item, index) => {
          return (
            <Tab
              key={index}
              style={{ backgroundColor: `${selectedTab === index + 1 ? "#333" : ""}` }}
              onClick={() => {
                navigate(props.route + `?page=1&tab=${index + 1}`, {
                  replace: true,
                });
              }}
            >
              {item.title}
            </Tab>
          );
        })}
      </TableTopFilterWrapper>
    </>
  );
}

export default TableTopFilter;

const TableTopFilterWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 17px;
`;

const Tab = styled.button.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 13px;
  border-radius: 21px;
  background: #939393;
  color: #fff;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;
  line-height: 22.75px; /* 162.5% */
`;
